"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _constants = require("composer-lib/lib/constants");

var BASE_PATH = '/users/v1/app/attributes';
var blogUserAttributeKeys = Object.keys(_constants.BlogUserAttributes).map(function (k) {
  return _constants.BlogUserAttributes[k];
});

var UserAttributesManager = /*#__PURE__*/function () {
  function UserAttributesManager() {
    (0, _classCallCheck2.default)(this, UserAttributesManager);
  }

  (0, _createClass2.default)(UserAttributesManager, [{
    key: "fetch",
    value: function fetch(userId) {
      return _apiClient.default.get(BASE_PATH, {
        query: {
          keys: blogUserAttributeKeys,
          userId: userId
        }
      });
    }
  }, {
    key: "updateAttribute",
    value: function updateAttribute(userId, attribute, value) {
      if (blogUserAttributeKeys.indexOf(attribute) === -1) {
        return Promise.reject('Cannot update non-blog user attributes');
      }

      var formattedValue = Array.isArray(value) || typeof value === 'object' ? JSON.stringify(value) : value;
      return _apiClient.default.post(BASE_PATH, {
        data: {
          key: attribute,
          userId: userId,
          value: formattedValue
        }
      });
    }
  }]);
  return UserAttributesManager;
}();

exports.default = UserAttributesManager;
module.exports = exports.default;